import { Component, input, model, output } from '@angular/core';
import { FilePreviewHandlerComponent } from '@sia/file-system';
import { AI_FILE_PREVIEW_PROVIDER } from '../../services/ai-file-preview.provider';

/**
 * Wrapper del componente generico FilePreviewHandlerComponent
 * che fornisce il provider AI-specifico per le chiamate API.
 * Mantiene il selettore originale per retrocompatibilita.
 */
@Component({
  selector: 'ai-preview-handler',
  imports: [FilePreviewHandlerComponent],
  template: `
    <sia-file-preview-handler
      [(isFullscreenMode)]="isFullscreenMode"
      [showFileName]="showFileName()"
      [showOcr]="true"
      [horizontal]="horizontal()"
      [fileType]="fileType()"
      [fileId]="fileSha256()"
      [fileName]="fileName()"
      (loadingPreview)="loadingPreview.emit($event)"
    ></sia-file-preview-handler>
  `,
  styles: [':host { display: contents; }'],
  providers: [AI_FILE_PREVIEW_PROVIDER],
})
export class AiPreviewHandlerComponent {
  isFullscreenMode = model<boolean>(false);
  showFileName = input<boolean>(false);
  horizontal = input<boolean>(false);
  fileType = input<string | undefined>();
  fileSha256 = input<string>('');
  fileName = input<string>('');
  loadingPreview = output<boolean>();
}
